import Vue from "vue";
import "./plugins/fontawesome";
import App from "./App.vue";
import "./plugins/element.js";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VCharts from 'v-charts';
import "../public/_main.css";
import "../public/home.css";
Vue.use(VCharts);
Vue.config.productionTip = false;
Vue.use(require("vue-shortkey"));
new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
